export const MONITORING_DASHBOARDS_DEFAULT_TIMESPAN = 30 * 60 * 1000;

export const MONITORING_DASHBOARDS_VARIABLE_ALL_OPTION_KEY = 'ALL_OPTION_KEY';

export type ColumnStyle = {
  alias?: string;
  decimals?: number;
  unit?: string;
  pattern: string;
  type: string;
};

type ValueMap = {
  op: string;
  text: string;
  value: string;
};

type YAxis = {
  format: string;
};

export type Panel = {
  breakpoint?: string;
  datasource?: DataSource;
  decimals?: number;
  format?: string;
  gridPos?: {
    h: number;
    w: number;
    x: number;
    y: number;
  };
  id: string;
  legend?: {
    show: boolean;
  };
  options?: {
    fieldOptions: {
      thresholds: {
        color?: string;
        value: number;
      }[];
    };
  };
  panels: Panel[];
  postfix?: string;
  postfixFontSize?: string;
  prefix?: string;
  prefixFontSize?: string;
  span: number;
  stack: boolean;
  styles?: ColumnStyle[];
  targets: Array<{
    expr: string;
    legendFormat?: string;
    refId: string;
  }>;
  title: string;
  transform?: string;
  type: string;
  units?: string;
  valueFontSize?: string;
  valueMaps?: ValueMap[];
  yaxes: YAxis[];
};

export type TemplateVariable = {
  datasource: DataSource;
  hide: number;
  includeAll: boolean;
  name: string;
  options: { selected: boolean; value: string }[];
  query: string;
  type: string;
};

export type Row = {
  collapse?: boolean;
  panels: Panel[];
  showTitle?: boolean;
  title?: string;
};

export type Board = {
  data: {
    panels: Panel[];
    rows: Row[];
    templating: {
      list: TemplateVariable[];
    };
    tags: string[];
    title: string;
  };
  name: string;
};

export type TimeDropdownsProps = {
  namespace?: string;
};

export type DataSource = {
  name: string;
  type: string;
};
